/**
 * Đọc ngữ cảnh từ URL.
 * Khách:   /v/{token}
 * Author:  /v/{token}?edit={authKey}
 * Embed:   /v/{token}?embed=1
 * Deep-link chi tiết: /v/{token}?partID={mã tem} → viewer tự tìm + zoom như quét QR.
 * Dev tiện: ?token={token} (khi chạy ở root, chưa có rewrite /v/*)
 */
export type ViewerMode = 'view' | 'author';

export interface ViewerRoute {
  token: string | null;
  authKey: string | null;
  mode: ViewerMode;
  embed: boolean;
  /** Dev-only: ?demo=1 → tải fixture đóng gói, không gọi backend. */
  demo: boolean;
  /** ?airender=1 → tự mở panel AI Render (deep-link từ Console; cần token, thường kèm ?edit=). */
  airender: boolean;
  /** /v/{token}/gallery (hoặc ?gallery=1) → trang gallery ảnh render CÔNG KHAI (chỉ ảnh đã lưu), KHÔNG tải model 3D. */
  gallery: boolean;
  /** ?partID={mã tem} → sau khi model tải xong, tìm + zoom vào chi tiết như quét QR (deep-link tem). Vắng = null. */
  partId: string | null;
}

export function parseRoute(loc: Location = window.location): ViewerRoute {
  const params = new URLSearchParams(loc.search);

  // token: ưu tiên path /v/{token}, fallback ?token= cho dev
  let token: string | null = null;
  const m = loc.pathname.match(/\/v\/([^/?#]+)/);
  if (m) token = decodeURIComponent(m[1]);
  if (!token) token = params.get('token');

  const authKey = params.get('edit');
  const embed = params.get('embed') === '1';
  // Gallery công khai: path /v/{token}/gallery (hoặc ?gallery=1 cho dev khi chạy ở root).
  const gallery =
    /\/v\/[^/?#]+\/gallery\/?(?:[?#]|$)/.test(loc.pathname) || params.get('gallery') === '1';

  // partID: nhận không phân biệt hoa/thường (partID/partId/partid). URLSearchParams so khớp key
  // phân biệt hoa-thường nên phải duyệt entries. Chuỗi rỗng → null (coi như không có).
  let partId: string | null = null;
  for (const [k, v] of params) {
    if (k.toLowerCase() === 'partid') {
      partId = v.trim() || null;
      break;
    }
  }

  return {
    token,
    authKey,
    mode: authKey ? 'author' : 'view',
    embed,
    demo: params.get('demo') === '1',
    airender: params.get('airender') === '1',
    gallery,
    partId,
  };
}

/** Thiết bị (cho analytics + tinh chỉnh hiệu năng). */
export function detectDevice(): 'pc' | 'mobile' {
  return matchMedia('(pointer: coarse)').matches || innerWidth < 768 ? 'mobile' : 'pc';
}
